import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

type HoverIconProps =
  | {
      className?: string;
      icon: BenchlingIconName;
    }
  | {
      className?: string;
      icon: BenchlingIconName;
      onClick: (result: object) => void;
      result: object;
    };

export default class HoverIcon extends React.Component<HoverIconProps> {
  static propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    result: PropTypes.object,
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleClick = (e: ElementMouseEvent) => {
    // Don't propogate so we don't trigger parent handlers.
    e.stopPropagation();
    // eslint-disable-next-line benchlint/no-in-operator
    if ('onClick' in this.props) {
      this.props.onClick(this.props.result);
    }
  };

  render(): JSX.Element {
    return (
      <div className={classNames('hoverLink', this.props.className)} onClick={this._handleClick}>
        <BenchlingIcon className="hoverLink-icon" icon={this.props.icon} />
      </div>
    );
  }
}
